module.exports = "//static.hsappstatic.net/marketplace-storefront-base/static-1.10038/assets/images/app-marketplace.jpg"